import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';
import { HANDLES } from './consts';
import type { OpenXAgentResizeEvent, ResizeDirection } from './types';

type ResizeHandleItemProps = {
  direction: ResizeDirection;
  cursor: string;
  sx: SxProps<Theme>;
  onResizeStart: (direction: ResizeDirection, event: OpenXAgentResizeEvent) => void;
};

const ResizeHandleItem = ({ direction, cursor, sx, onResizeStart }: ResizeHandleItemProps) => {
  const handleMouseDown = (event: OpenXAgentResizeEvent) => {
    onResizeStart(direction, event);
  };

  return (
    <Box
      data-test={`resize-handle-${direction}`}
      onMouseDown={handleMouseDown}
      sx={{
        position: 'absolute',
        userSelect: 'none',
        cursor,
        ...sx,
      }}
    />
  );
};

type ResizeHandlesProps = {
  onResizeStart: (direction: ResizeDirection, event: OpenXAgentResizeEvent) => void;
};

export const ResizeHandles = ({ onResizeStart }: ResizeHandlesProps) => {
  return (
    <>
      {HANDLES.map(({ direction, cursor, sx }) => (
        <ResizeHandleItem key={direction} direction={direction} cursor={cursor} sx={sx} onResizeStart={onResizeStart} />
      ))}
    </>
  );
};
